import { postersList } from "../../../data/PostersListData";
import "./PostersList.css";
import {TopBar} from "../../top-bar/TopBar";
import {PublicOptions} from "../../../data/publicOptions";
import {Footer} from "../../footer/Footer";

export const PostersList = () => (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
        <div className="posters-list-container">
          <h2>Poster session 1</h2>
          <div className="posters-list-table-wrapper">
            <table className="posters-list-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Authors</th>
                  <th>Affiliations</th>
                </tr>
              </thead>
              <tbody>
                {postersList.map((poster, idx) => (
                  <tr key={idx}>
                    <td>{poster.title}</td>
                    <td>
                      {poster.authors && poster.authors.map((author, i) => (
                        <span key={i}>{author}{i < poster.authors.length - 1 ? ", " : ""}</span>
                      ))}
                    </td>
                    <td>
                      {poster.affiliations && poster.affiliations.map((aff, i) => (
                        <span key={i}>{aff}{i < poster.affiliations.length - 1 ? ", " : ""}</span>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        </section>
        </div>
      <Footer/>
    </>
);

